import { render, staticRenderFns } from "./JobPostingJsonLD.vue?vue&type=template&id=fde4886a&"
import script from "./JobPostingJsonLD.vue?vue&type=script&lang=ts&"
export * from "./JobPostingJsonLD.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports